<template>
    <div>
        <Dialog v-bind:value="value" @input="$emit('input', $event)"
                :title="selectedUser ? 'Benutzer bearbeiten' : 'Neuen Benutzer anlegen'"
                :ok-disabled="!validate"
                :loading="loading"
                @ok="submit"
                @cancel="close"
        >
            <Input v-model.trim="mail" label="Email"
                   :error-messages="mailErrors"
                   :required="true"
                   @blur="$v.mail.$touch()"></Input>
            <Dropdown v-model="role" label="Benutzerrolle" :items="this.$store.state.users.roles" :return-object="false"
                      :error-messages="roleErrors" @blur="$v.role.$touch()"
                      item-value="value"></Dropdown>
            <div v-if="userDetails && data">
                <!--<Toggle :hide-details="true" v-model="data.User.IsAdmin"
                        label="Admin Rechte"></Toggle>
                <Toggle v-model="data.User.CanContextual"
                        label="Contextual Rechte"></Toggle>-->
                <div class="mt-4">
                    <h4>Erlaubte Publisher</h4>
                    <div>
                        <Toggle v-for="(publ, i) in data.Publisher" :key="'publisherToggle_'+i"
                                v-model="data.Publisher[i].IsAllowed"
                                :label="publ.Name"
                                :hide-details="true"
                        ></Toggle>
                    </div>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
import Utils from "../../scripts/Utils";
import Input from "../../components/Inputs/Input";
import Dialog from "../../components/Dialog";
import ada from "../../scss/ada_colors.scss";
import Toggle from "../../components/buttons/Toggle";
import {validationMixin} from "vuelidate";
import {required, email} from "vuelidate/lib/validators";
import Dropdown from "../../components/Inputs/Dropdown";


export default {
    name: "AddEditUserDialog",
    components: {Dropdown, Toggle, Dialog, Input},
    props: ['value'],
    mixins: [validationMixin],
    validations: {
        mail: {required, email},
        role: {required},
    },
    data: () => {
        return {
            data: null,
            mail: null,
            loading: false,
            delete_loading: false,
            role: null,
            ada
        }
    },
    mounted() {
        this.init();
    },
    computed: {
        vuexState() {
            return this.$store.state.users;
        },
        selectedUser() {
            return this.vuexState.selectedUser;
        },
        userDetails() {
            return this.vuexState.userDetails;
        },
        mailErrors() {
            return Utils.handleError(this, 'mail', {
                required: 'Email ist erforderlich.',
                email: 'Bitte eine gültige Email angeben.'
            });
        },
        roleErrors() {
            return Utils.handleError(this, 'role', {
                required: 'Benutzerrolle ist erforderlich.'
            });
        },
        validate() {
            return this.mailErrors.length === 0;
        },
        readOnly() {
            return this.$store.state.readOnly;
        }
    },
    methods: {
        init() {
            if (this.userDetails) {
                this.data = JSON.parse(JSON.stringify(this.userDetails));
                this.mail = this.userDetails.User.Mail;
                this.role = this.userDetails.User.Group;
            } else {
                this.mail = null;
                this.data = null;
                this.role = null;
            }
        },
        async submit() {
            this.$v.$touch();
            if (this.validate) {
                this.loading = true;
                try {
                    let data = await this.$store.dispatch('users/editUser', this.getBody());
                    this.loading = false;
                    if (data.Status) {
                        let msg = this.userDetails ? 'Erfolgreich gespeichert.' : 'Benutzer erfolgreich angelegt.';
                        this.$root.$emit('snackbar', msg);
                        this.close();
                    }
                } catch (e) {
                    this.loading = false;
                }
            }
        },
        getBody() {
            let json = {
                Mail: this.mail,
                Group: this.role,
            };
            if (this.userDetails) {
                json.user_id = this.userDetails.User.UserId;
                json.IsAdmin = this.data.User.IsAdmin;
                json.Group = this.role;
                json.PasswordChange = 0;
                let allowedPublisher = this.data.Publisher.filter(x => x.IsAllowed === 1);
                if (allowedPublisher.length !== 0) {
                    json.publisherAllowed = {};
                    allowedPublisher.forEach((publ) => {
                        json.publisherAllowed[publ.PublisherId] = 1;
                    })
                }
            }
            return json;
        }
        ,
        close() {
            this.$emit('input', false); // set v-model to false -> close dialog
        },
    },
    watch: {
        userDetails() {
            this.init();
        },
        value(n) {
            if (!n) {
                this.init();
                this.$v.$reset();
            }
        }
    }
}
</script>

<style lang="scss" scoped>

::v-deep tbody tr {
    cursor: pointer;
}

</style>